/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";

/*------------------------------------*\
    TESTIMONIAL CAROUSEL
\*------------------------------------*/
class TestimonialCarouselModule {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.primaryCarouselElem = self.elem.querySelector('[testimonial-data-carousel]');
    }

    init() {
        let self = this;

        self.initCarousels();
    }

    initCarousels() {
        let self = this;

        const flktyPrimary = new Flickity(self.primaryCarouselElem, {
            pageDots: false,
            groupCells: true,
            contain: true,
            resize: true,
            wrapAround: true,
            setGallerySize: false,
            autoPlay: 5000,
        });
    }

}

export default TestimonialCarouselModule;